export function isNullOrUndefined(value: any) {
    return value === undefined || value === null;
}